import * as types from './types';

export const setSelectedTab = value => {
  return {
    type: types.SITESETUP_SET_SELECTED_TAB,
    payload: value,
  };
};

export const setShowLicensed = value => {
  return {
    type: types.SITESETUP_SET_SHOW_ISLICENSED,
    payload: value,
  };
};
export const setShowActive = value => {
  return {
    type: types.SITESETUP_SET_SHOW_ISACTIVE,
    payload: value,
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/settings/actions.js